<div class="cheat-sheet">
  <div class="cheat-sheet__header">
    <h2>{{ 'Label.KeyboardShortcuts' | translate }}</h2>
    <button
      type="button"
      class="cheat-sheet__close inline-flex items-center justify-center w-density-button aspect-square rounded-md text-warm-secondary transition-colors hover:bg-warm-hover hover:text-warm-text"
      (click)="dialogRef.close()"
      aria-label="Close keyboard shortcuts"
    >
      <span class="material-symbols-outlined icon-size-token-sm">close</span>
    </button>
  </div>

  <div class="cheat-sheet__body">
    @for (group of shortcutGroups; track group.category) {
      <div class="cheat-sheet__group">
        <div class="cheat-sheet__group-header">
          <span class="material-symbols-outlined">{{ group.icon }}</span>
          <span>{{ group.category }}</span>
        </div>
        @for (shortcut of group.shortcuts; track shortcut.description) {
          <div class="cheat-sheet__row">
            <span class="cheat-sheet__description">{{ shortcut.description }}</span>
            <div class="cheat-sheet__keys">
              @for (key of shortcut.keys; track key; let last = $last) {
                <kbd class="cheat-sheet__key">{{ key }}</kbd>
                @if (!last) {
                  <span class="cheat-sheet__plus">+</span>
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
